(() => {
  'use strict';
  function init(root = document) {
    const page = root.matches?.('[data-ela-editorial]') ? root : root.querySelector('[data-ela-editorial]');
    if (!page || page.dataset.elaReady) return;
    page.dataset.elaReady = 'true';
    const thumbs = [...page.querySelectorAll('[data-ela-view]')];
    const main = page.querySelector('[data-ela-gallery-image]');
    const mainButton = page.querySelector('[data-ela-zoom-main]');
    const caption = page.querySelector('[data-ela-gallery-caption]');
    const dialog = page.querySelector('[data-ela-lightbox]');
    const large = dialog.querySelector('[data-ela-lightbox-image]');
    const title = dialog.querySelector('[data-ela-lightbox-caption]');
    const count = dialog.querySelector('[data-ela-lightbox-count]');
    const sizeButton = dialog.querySelector('[data-ela-lightbox-size]');
    const viewport = dialog.querySelector('.ela-lightbox__viewport');
    let selected = 0;
    let enlarged = 0;
    let opener;
    const resetSize = () => {
      dialog.classList.remove('is-actual');
      sizeButton.setAttribute('aria-pressed', 'false');
      sizeButton.textContent = 'Taille réelle';
      viewport.scrollTop = 0;
      viewport.scrollLeft = 0;
    };
    function select(index) {
      selected = index;
      const thumb = thumbs[index];
      main.removeAttribute('srcset');
      main.src = thumb.dataset.src + '&width=1254';
      main.alt = thumb.dataset.alt;
      caption.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(thumbs.length).padStart(2, '0') + ' · ' + thumb.dataset.alt;
      mainButton.setAttribute('aria-label', 'Agrandir : ' + thumb.dataset.alt);
      thumbs.forEach((item, i) => {
        item.classList.toggle('is-active', i === index);
        item.setAttribute('aria-pressed', String(i === index));
      });
    }
    function show(index) {
      enlarged = (index + thumbs.length) % thumbs.length;
      const item = thumbs[enlarged];
      large.src = item.dataset.src;
      large.alt = item.dataset.alt;
      title.textContent = item.dataset.alt;
      count.textContent = (enlarged + 1) + ' / ' + thumbs.length;
      resetSize();
    }
    function open(index, trigger) {
      if (typeof dialog.showModal !== 'function') {
        window.open(thumbs[index].dataset.src, '_blank', 'noopener');
        return;
      }
      opener = trigger;
      show(index);
      dialog.showModal();
      dialog.querySelector('[data-ela-lightbox-close]').focus();
    }
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => select(index)));
    mainButton.addEventListener('click', () => open(selected, mainButton));
    page.querySelectorAll('[data-ela-zoom]').forEach(button => {
      button.addEventListener('click', () => {
        const index = thumbs.findIndex(thumb => thumb.dataset.src === button.dataset.elaZoom);
        if (index >= 0) open(index, button);
      });
    });
    dialog.querySelector('[data-ela-lightbox-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { resetSize(); opener?.focus({ preventScroll: true }); });
    dialog.querySelector('[data-ela-lightbox-prev]').addEventListener('click', () => show(enlarged - 1));
    dialog.querySelector('[data-ela-lightbox-next]').addEventListener('click', () => show(enlarged + 1));
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        dialog.close();
        return;
      }
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        if (dialog.classList.contains('is-actual')) return;
        event.preventDefault();
        show(enlarged + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    sizeButton.addEventListener('click', () => {
      const actual = dialog.classList.toggle('is-actual');
      sizeButton.setAttribute('aria-pressed', String(actual));
      sizeButton.textContent = actual ? 'Adapter à l’écran' : 'Taille réelle';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

